import { reportTypes } from '../../utils/reports';
import {
    getBaseConfig,
    getCompare,
    getDatePicker,
    getEmptyStateConfig,
    getRegularMode,
    getSecondDatePicker,
    getVsLabel,
    shelfAttributionInsightsDimensions,
    shelfCohortMetrics,
    shelfConversionEvents,
    shelfCreativeMeasurement,
    shelfCustomDimensions,
    shelfCustomEvents,
    shelfDimensions,
    shelfDiscrepancies,
    shelfGovernanceDimensions,
    shelfMediaPropertiesDimensions,
    shelfMetadataDimensions,
    shelfMetrics,
    shelfNetworkData,
    shelfPromotedContentDetails,
    shelfReportingAppMetrics,
    shelfTimeBreakdowns,
    shelfTrackerData,
    shelfVideoMetrics,
} from './baseReportConfig';
import { shelfPeriods } from './shelfPeriods';
import { FIELD_SECTION } from '../../components/pages/reports/consts';

const type = reportTypes.creativeExplore;
const path = '/react/creative-explore';
const basicConfig = getBaseConfig(type, 'STATIC.PAGE_HEADERS.CREATIVE_EXPLORE');
const PERMISSION_KEY_DISPLAY_ALIGNMENT = 'display_alignment';

const shelfShowCreativePreview = {
    type: 'creativeShowPreview',
    addButton: {
        show: false,
    },
    group: {
        type: 'multi',
    },
    section: FIELD_SECTION.DIMENSIONS,
};

const marginSelector = (config, margin = '10px 0 0 0') => {
    return {
        selector: state => {
            const baseResult = config.selector(state);
            return {
                ...baseResult,
                containerStyle: {
                    ...baseResult.containerStyle,
                    margin,
                },
            };
        },
    };
};

const shelfCreativesAIDimensions = {
    type: 'creativesAIDimensions',
    addButton: {
        show: false,
    },
    group: {
        type: 'multi',
        subText: 'STATIC.PAGES.CREATIVE_EXPLORE.CREATIVES_AI_DIMENSIONS_SUBTEXT',
    },
    label: 'STATIC.PAGES.CREATIVE_EXPLORE.CREATIVES_AI_DIMENSIONS_LABEL',
    section: FIELD_SECTION.AI_TAGS,
};

const shelfCreativesAICustomDimensions = {
    type: 'creativesAICustomDimensions',
    addButton: {
        show: false,
    },
    group: {
        type: 'multi',
        subText: 'STATIC.PAGES.CREATIVE_EXPLORE.CREATIVES_AI_CUSTOM_DIMENSIONS_SUBTEXT',
    },
    label: 'STATIC.PAGES.CREATIVE_EXPLORE.CREATIVES_AI_CUSTOM_DIMENSIONS_LABEL',
    section: FIELD_SECTION.AI_TAGS,
};

const datePickerConfig = getDatePicker(type);
const vsLabelConfig = getVsLabel(type);
const secondDatePicker = getSecondDatePicker(type);
const compareConfig = getCompare(type);
const regularModeConfig = getRegularMode(type);

const shelfDisplayAlignment = {
    type: 'checkbox',
    field: 'displayAlignment',
    label: 'Show Creative Alignment',
    bigLabel: 'STATIC.CREATIVE_ALIGNMENT',
    renderChildrenOnly: true,
    bigLabelTooltip: 'STATIC.TOOLTIPS.CREATIVE_ALIGNMENT',
    section: FIELD_SECTION.CHECKBOXES,
    permissionKey: PERMISSION_KEY_DISPLAY_ALIGNMENT,
    isShowAdmin: true,
};

export default {
    ...basicConfig,
    fieldShowDownloadReport: {
        country_field: true,
    },
    path,
    chart: {
        enabled: true,
        show: false,
        lines: 5,
        showLegend: true,
    },
    header: {
        ...basicConfig.header,
        leftComponents: [
            {
                ...datePickerConfig,
                ...marginSelector(datePickerConfig),
            },
            {
                ...vsLabelConfig,
                selector: state => {
                    const baseResult = vsLabelConfig.selector(state);
                    return {
                        ...baseResult,
                        style: {
                            ...baseResult.style,
                            margin: '10px 10px 5px',
                        },
                    };
                },
            },
            {
                ...secondDatePicker,
                ...marginSelector(secondDatePicker),
            },
            {
                ...compareConfig,
                ...marginSelector(compareConfig),
            },
            {
                ...regularModeConfig,
                ...marginSelector(regularModeConfig),
            },
        ],
        subText: {
            faqLink: 'https://support.singular.net/hc/en-us/articles/37458750249883-Creative-Explore-FAQ',
            hideVideo: true,
        },
        emptyStateHeaderData: getEmptyStateConfig('CREATIVE_EXPLORE'),
    },
    fieldWarnings: {},
    shelf: [
        shelfTimeBreakdowns,
        shelfShowCreativePreview,
        shelfDimensions,
        shelfMetadataDimensions,
        shelfAttributionInsightsDimensions,
        shelfCreativeMeasurement,
        shelfPromotedContentDetails,
        shelfMediaPropertiesDimensions,
        shelfGovernanceDimensions,
        shelfCustomDimensions,
        shelfCreativesAIDimensions,
        shelfCreativesAICustomDimensions,
        shelfMetrics,
        shelfReportingAppMetrics,
        shelfVideoMetrics,
        shelfCohortMetrics,
        shelfConversionEvents,
        shelfCustomEvents,
        shelfPeriods,
        shelfTrackerData,
        shelfNetworkData,
        shelfDiscrepancies,
        shelfDisplayAlignment,
    ],
};
